// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentDefaultWrapper_wrapper__nHiFJ","header":"ContentDefaultWrapper_header__h5XnI","actions":"ContentDefaultWrapper_actions__asz6f"};